module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    class: _vm.getClassMobile(),
    style: (_vm.modalStyle()),
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    style: (_vm.mainDivStyle())
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "20px",
      "margin-top": "30px",
      "cursor": "pointer",
      "z-index": "101"
    }
  }, [_c('img', {
    staticClass: "modal-back-arrow",
    attrs: {
      "src": require("../assets/img/icons/arrow_left.svg")
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "my-trainings-title"
  }, [_vm._v(_vm._s(_vm.locale.t("label_crop_image")))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.visibleCrop) ? _c('div', {
    staticStyle: {
      "height": "400px",
      "margin-top": "50px"
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "height": "400px"
    },
    attrs: {
      "id": "image1",
      "src": "#",
      "alt": "Odabrana slika"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "new-button",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "cropButton1"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_crop_image")))]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "height": "30px"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-314347cd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/CropImageModal.vue
// module id = 732
// module chunks = 0